import {
  Box,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { GiSouthKorea } from 'react-icons/gi';
import { TbDeviceAnalytics } from 'react-icons/tb';
import { PiBuildingApartmentLight } from 'react-icons/pi';
import { MdOutlineAnalytics } from 'react-icons/md';

const steps = [
  {
    icon: <GiSouthKorea />,
    number: '01',
    title: '전국 흐름 파악',
    description: '전국과 시도별 지표를 살펴보며 시장의 방향과 지역별 차이를 파악합니다.',
  },
  {
    icon: <TbDeviceAnalytics />,
    number: '02',
    title: '지역 분석',
    description: '미분양, 입주물량, 전세가율 등을 비교하며 관심 지역을 구체적으로 분석합니다.',
  },
  {
    icon: <PiBuildingApartmentLight />,
    number: '03',
    title: '아파트 선정',
    description: '검색과 지도로 후보를 찾고 가격과 입지를 비교해 내 기준에 맞는 아파트를 선정합니다.',
  },
  {
    icon: <MdOutlineAnalytics />,
    number: '04',
    title: '분석 노트로 지속 관찰',
    description: '분석과 생각을 나만의 노트에 모으고, 관심 지역과 아파트의 변화를 꾸준히 관찰합니다.',
  },
];

export const HomeProcess = () => {
  return (
    <Box
      sx={{
        py: { xs: 10, md: 16 },
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'neutral.900' : 'neutral.50',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={2}
          sx={{ mb: { xs: 8, md: 10 }, textAlign: 'center', alignItems: 'center' }}
        >
          <Typography
            variant="overline"
            sx={{ color: 'primary.main', fontWeight: 700, letterSpacing: 2 }}
          >
            Process
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 800, fontSize: { xs: 28, md: 40 } }}
          >
            살펴보고, 비교하고, 기록하며 관찰하세요
          </Typography>
          <Typography
            color="text.secondary"
            sx={{ fontSize: { xs: 16, md: 18 }, maxWidth: 500, mx: 'auto' }}
          >
            전국 흐름에서 시작해 나만의 분석 노트로 이어지는 4단계.
          </Typography>
        </Stack>

        <Grid
          container
          spacing={3}
        >
          {steps.map((step, index) => (
            <Grid
              key={step.number}
              xs={12}
              sm={6}
              md={3}
            >
              <Box
                sx={{
                  position: 'relative',
                  p: 4,
                  height: '100%',
                  borderRadius: 3,
                  backgroundColor: 'background.paper',
                  border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: (theme) =>
                      `0 12px 32px ${alpha(theme.palette.common.black, 0.08)}`,
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 48,
                    fontWeight: 900,
                    color: (theme) => alpha(theme.palette.primary.main, 0.1),
                    lineHeight: 1,
                    mb: 3,
                  }}
                >
                  {step.number}
                </Typography>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: 'primary.alpha12',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                  }}
                >
                  <SvgIcon sx={{ fontSize: 24, color: 'primary.main' }}>
                    {step.icon}
                  </SvgIcon>
                </Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, mb: 1 }}
                >
                  {step.title}
                </Typography>
                <Typography
                  color="text.secondary"
                  variant="body2"
                  sx={{ lineHeight: 1.7 }}
                >
                  {step.description}
                </Typography>

                {/* Connector line (except last) */}
                {index < steps.length - 1 && (
                  <Box
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      position: 'absolute',
                      top: '50%',
                      right: -18,
                      width: 36,
                      height: 2,
                      backgroundColor: 'divider',
                    }}
                  />
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
